import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import SearchBar from "@/components/base/SearchBar";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "动漫", to: "/category/anime" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setSearchOpen(false);
  }, [location.pathname, location.search]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b bg-background-50/95 backdrop-blur transition-colors ${
        scrolled ? "border-background-300" : "border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center gap-4 px-4 md:px-6">
        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 md:hidden"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
        </button>

        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-play-fill text-xl" aria-hidden="true" />
          </span>
          <span className="font-heading text-lg font-extrabold tracking-tight text-foreground-950">
            色虎视频
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-full max-w-sm md:block">
          <SearchBar />
        </div>

        <button
          type="button"
          onClick={() => setSearchOpen(true)}
          className="ml-auto flex h-9 w-9 cursor-pointer items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 md:hidden"
          aria-label="搜索"
        >
          <i className="ri-search-line text-xl" aria-hidden="true" />
        </button>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="mx-auto flex max-w-[1280px] flex-col px-4 py-2" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive ? "bg-primary-100 text-primary-700" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400" aria-hidden="true" />
              </NavLink>
            ))}
          </nav>
        </div>
      ) : null}

      {searchOpen ? (
        <div className="fixed inset-0 z-[60] flex flex-col bg-background-50 px-4 pt-5 md:hidden">
          <div className="flex items-center gap-2">
            <div className="flex-1">
              <SearchBar size="lg" autoFocus />
            </div>
            <button
              type="button"
              onClick={() => setSearchOpen(false)}
              className="flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-md text-foreground-700 hover:bg-background-100"
              aria-label="关闭搜索"
            >
              <i className="ri-close-line text-2xl" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            {["科幻", "悬疑", "喜剧", "动作", "动漫", "综艺"].map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => navigate(`/search?q=${encodeURIComponent(tag)}`)}
                className="cursor-pointer rounded-full border border-background-200 px-3 py-1.5 text-sm text-foreground-600"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}